import * as React from 'react';

const NoDiscounts: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='160'
		height='160'
		viewBox='0 0 160 160'
		fill='none'>
		<path
			d='M89.3272 33.5491C86.7828 32.0872 83.7415 31.7462 80.9341 32.6082L49.046 42.3989C43.766 44.0201 40.6344 49.4181 41.8638 54.7795L49.288 87.1586C49.9416 90.0093 51.759 92.46 54.3034 93.922L101.831 121.231C106.882 124.133 113.34 122.411 116.256 117.384L140.72 75.2141C143.636 70.1875 141.906 63.76 136.855 60.8579L89.3272 33.5491Z'
			fill='black'
		/>

		<foreignObject x='-16' y='14.5654' width='130' height='159'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_0_2148_30991_clip_path)',
					height: '100%',
					width: '100%',
				}}
			/>
		</foreignObject>

		<path
			data-figma-bg-blur-radius='30'
			d='M84 77.9245C84 74.9775 82.7769 72.1637 80.6246 70.1594L56.1774 47.3927C52.1294 43.623 45.8706 43.623 41.8226 47.3927L17.3754 70.1594C15.2231 72.1637 14 74.9775 14 77.9245V132.973C14 138.823 18.7247 143.565 24.5528 143.565H73.4472C79.2753 143.565 84 138.823 84 132.973V77.9245Z'
			fill='#D3D3D3'
			fillOpacity={0.3}
		/>

		<path
			d='M34 91.4064C34 89.4572 34.588 87.9094 35.7641 86.7628C36.9402 85.5876 38.4461 85 40.2819 85C42.1177 85 43.6236 85.5876 44.7997 86.7628C45.9758 87.9094 46.5638 89.4572 46.5638 91.4064C46.5638 93.3842 45.9758 94.9607 44.7997 96.1359C43.6236 97.2825 42.1177 97.8558 40.2819 97.8558C38.4461 97.8558 36.9402 97.2825 35.7641 96.1359C34.588 94.9607 34 93.3842 34 91.4064ZM56.2192 85.473C57.51 85.473 58.3153 86.8719 57.6672 87.9881L42.1858 114.65C41.8862 115.166 41.3345 115.484 40.7378 115.484C39.447 115.484 38.6417 114.085 39.2898 112.969L54.7711 86.3066C55.0708 85.7905 55.6224 85.473 56.2192 85.473ZM40.2819 87.4078C39.3066 87.4078 38.5321 87.7517 37.9585 88.4397C37.4135 89.0989 37.1409 90.0878 37.1409 91.4064C37.1409 92.7249 37.4135 93.7282 37.9585 94.4161C38.5321 95.104 39.3066 95.448 40.2819 95.448C41.2572 95.448 42.0317 95.104 42.6053 94.4161C43.179 93.6995 43.4659 92.6963 43.4659 91.4064C43.4659 90.0878 43.179 89.0989 42.6053 88.4397C42.0317 87.7517 41.2572 87.4078 40.2819 87.4078ZM50.4792 109.551C50.4792 107.573 51.0673 106.011 52.2433 104.864C53.4194 103.689 54.9253 103.101 56.7611 103.101C58.5969 103.101 60.0885 103.689 61.2359 104.864C62.412 106.011 63 107.573 63 109.551C63 111.5 62.412 113.062 61.2359 114.237C60.0885 115.412 58.5969 116 56.7611 116C54.9253 116 53.4194 115.427 52.2433 114.28C51.0673 113.105 50.4792 111.528 50.4792 109.551ZM56.7181 105.552C55.7428 105.552 54.9683 105.896 54.3947 106.584C53.821 107.243 53.5341 108.232 53.5341 109.551C53.5341 110.84 53.821 111.829 54.3947 112.517C54.9683 113.177 55.7428 113.506 56.7181 113.506C57.6934 113.506 58.4679 113.177 59.0415 112.517C59.6152 111.829 59.9021 110.84 59.9021 109.551C59.9021 108.232 59.6152 107.243 59.0415 106.584C58.4679 105.896 57.6934 105.552 56.7181 105.552Z'
			fill='white'
		/>

		<circle cx='48.5' cy='52.5' r='4.5' fill='white' />

		<defs>
			<clipPath id='bgblur_0_2148_30991_clip_path' transform='translate(16 -14.5654)'>
				<path d='M84 77.9245C84 74.9775 82.7769 72.1637 80.6246 70.1594L56.1774 47.3927C52.1294 43.623 45.8706 43.623 41.8226 47.3927L17.3754 70.1594C15.2231 72.1637 14 74.9775 14 77.9245V132.973C14 138.823 18.7247 143.565 24.5528 143.565H73.4472C79.2753 143.565 84 138.823 84 132.973V77.9245Z' />
			</clipPath>
		</defs>
	</svg>
);

export default NoDiscounts;
